export async function mockApiCall() {
	return true;
}
